module.exports = __webpack_public_path__ + "img/ape-constructor-title-shape.5f727ee6.svg";